import { addDays, addMinutes, addMonths, endOfDay, endOfMonth, format, roundToNearestMinutes, startOfDay, startOfYear } from "date-fns";

export enum TimeRange {
  Last30Days,
  Last12Months,
  YearToDate
}

export function startEndDateFromTimeRange(timeRange: TimeRange): { start: Date, end: Date } {

  switch (timeRange) {
    case TimeRange.Last30Days:
      return {
        start: startOfDay(addDays(new Date(), -30)),
        end: endOfDay(new Date())
      }
    case TimeRange.Last12Months:
      return {
        start: addDays(addMonths(endOfMonth(new Date()), -12), 1),
        end: endOfMonth(new Date())
      }
    case TimeRange.YearToDate:
      return {
        start: startOfYear(new Date()),
        end: endOfDay(new Date())
      }
    default:
      throw new Error(`not supported ${timeRange}`)
  }
}



export function toApiDateTime(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
  //return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}T${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  //'YYYY-MM-DDTHH:mm:ss'
}


export function toUTCDate(start: Date): Date {
  return new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate(), start.getUTCHours(), start.getUTCMinutes(), start.getUTCSeconds(), start.getUTCMilliseconds()))
}

export function toUTCDateNoSeconds(start: Date): Date {
  return new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate(), start.getUTCHours(), start.getUTCMinutes(), 0, 0))
}


export function isWholeDayTimeRange(start: Date, end: Date): boolean {
  if (!end)
    return false;
  if (!start)
    return false;

  const difference = end.getTime() - start.getTime();
  return difference === 24 * 60 * 60 * 1000;
}

export function timespanToString(value: number, ignoreSeconds?: boolean) {
  var sec_num = value / 1000; // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (minutes === 0 && seconds === 0 && hours !== 0)
    return hours + 'h';

  if (minutes !== 0 && hours !== 0 && seconds === 0)
    return hours + 'h ' + minutes + 'm';

  if (hours === 0 && minutes === 0)
    return seconds.toFixed(0) + 's';
  if (hours === 0)
    return ignoreSeconds ? minutes + 'm ' : minutes + 'm ' + seconds.toFixed(0) + 's';



  return ignoreSeconds ? hours + 'h ' + minutes + 'm ' : hours + 'h ' + minutes + 'm ' + seconds.toFixed(0) + 's';
}


export const is0oClock = (date: Date) => date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0;
export const isAlmost0oClock = (date: Date) => date.getHours() === 23 && date.getMinutes() === 59 && date.getSeconds() === 59;
export const diffDaysToMonday = (date: Date) => date.getDay() === 0 ? -7 : ((date.getDay() * -1));

export const getTimeRangeFromTimespan = (timespan: number) => {
  return { start: startOfDay(addMinutes(startOfDay(new Date()), -(timespan))), end: roundToNearestMinutes(new Date(), { nearestTo: 5 }) }
}